import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../axiosSetup";
import DataTable from "./DataTable";
import cfg from "../../config";

const HaesList = () => {
  const [haes, setHaes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHaes = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get("/api/all-haes-zunftrat", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setHaes(res.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchHaes();
  }, []);

  const boolBadge = (val) =>
    val ? <span className="dt-badge dt-badge-yes">Ja</span> : <span className="dt-badge dt-badge-no">Nein</span>;

  // Die Schnittstelle liefert neutrale Feldnamen und echte Wahrheitswerte.
  // Die Beschriftung entsteht hier und folgt den Begriffen aus der Konfiguration.
  const columns = [
    { key: "number", label: "Nummer",
      searchValue: (v) => String(v ?? "") },
    { key: "typ", label: "Typ",
      render: (v) => v ? <span className="dt-badge dt-badge-info">{v}</span> : <span className="dt-muted">—</span> },
    { key: "isKidsHaes", label: `Kinder-${cfg.costumeTerm}`,
      render: (v) => boolBadge(v) },
    { key: "hasTreadmills", label: "Laufbendel",
      render: (v) => boolBadge(v) },
    { key: "isRentHaes", label: "Leihgabe",
      render: (v) => boolBadge(v) },
    { key: "accessories", label: "Zubehör",
      render: (v) => v || <span className="dt-muted">—</span> },
    { key: "lastTreadmills", label: "Letzter Laufbendel",
      render: (v) => v || <span className="dt-muted">—</span> },
    {
      key: "owner", label: "Besitzer",
      render: (v) => v?.name || <span className="dt-muted">—</span>,
      searchValue: (v) => v?.name ?? "",
    },
    {
      key: "awarded", label: "Verliehen an",
      render: (v) => v?.name
        ? <span className="dt-badge dt-badge-warn">{v.name}</span>
        : <span className="dt-badge dt-badge-neutral">Nicht verliehen</span>,
      searchValue: (v) => v?.name ?? "",
    },
  ];

  const actions = (haesItem) => (
    <div className="dt-actions">
      <button className="dt-btn dt-btn-primary" onClick={() => navigate("/zr-haes-create", { state: { haesItem } })}>
        Bearbeiten
      </button>
    </div>
  );

  const headerActions = (
    <button className="dt-btn dt-btn-success" onClick={() => navigate("/zr-haes-create")}>
      + {cfg.costumeTerm} erstellen
    </button>
  );

  return (
    <div className="container-fluid px-3 px-md-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">{cfg.costumeTermPlural} verwalten</h2>
      </div>
      <DataTable
        data={haes}
        columns={columns}
        loading={loading}
        error={error}
        actions={actions}
        headerActions={headerActions}
        searchPlaceholder={`${cfg.costumeTerm} suchen…`}
        emptyText={`Keine ${cfg.costumeTermPlural} gefunden.`}
        initialPageSize={25}
        pageSizeOptions={[10, 25, 50, 100]}
      />
      <br />
    </div>
  );
};

export default HaesList;
